import { useAuth } from '../../context/AuthContext'
import {
  getTiposOrganizacionComercial, createTipoOrganizacionComercial, updateTipoOrganizacionComercial, deleteTipoOrganizacionComercial,
} from '../../api/client'
import { puede } from '../../components/comercial/comercialLogica'
import ComercialCatalogo from '../../components/comercial/ComercialCatalogo'

const API = {
  listar: () => getTiposOrganizacionComercial(),
  crear: createTipoOrganizacionComercial,
  actualizar: updateTipoOrganizacionComercial,
  eliminar: deleteTipoOrganizacionComercial,
}

// Comercial > Administración > Tipos de organización (Cliente, Distribuidor…).
// Takes comercial_configurar.
export default function ComercialTipos() {
  const { user } = useAuth()
  return <ComercialCatalogo api={API} textos="tipos" puede={puede(user, 'comercial_configurar')} />
}
